import {Account, AccountState, AccountType} from 'web-angular-client';

/**
 * Account states whose ecommerce payment can be refunded. Mirrors the authoritative engine set
 * ({@code RefundService.REFUND_ELIGIBLE_ACCOUNT_STATES}). The engine re-validates on every request, so this is a
 * UX-only gate that keeps the Refund action from appearing where the backend would reject it.
 */
export const REFUND_ELIGIBLE_ACCOUNT_STATES: ReadonlySet<AccountState> = new Set<AccountState>([
    AccountState.PAYMENT_COMPLETED,
    AccountState.PAYMENT_FEES_ISSUE,
    AccountState.PAYMENT_READY_FOR_SETTLEMENT,
    AccountState.PARTIAL_PAYMENT_RECEIVED,
    AccountState.SETTLEMENT_PROCESSED
]);

/**
 * Whether the merchant may refund this ecommerce transaction: it must be an ecommerce account in a refundable state
 * that the backend flagged as refund-eligible. The {@code account.refundEligible} flag is resolved server-side and
 * already incorporates both the payment network ({@code SourceNetwork.refundEligible}) and the configured refund
 * window, so no date math is needed here. The engine re-validates on every request; this is a UX-only gate.
 *
 * @param account the transaction/account row
 */
export function isRefundEligible(account: Account | null | undefined): boolean
{
    return !!account
        && account.accountType === AccountType.ECOMMERCE_RTP
        && account.accountState != null
        && REFUND_ELIGIBLE_ACCOUNT_STATES.has(account.accountState)
        && account.refundEligible === true;
}
